import { Typography } from "antd";
import { type TextProps as AntdTextProps } from "antd/lib/typography/Text";

import type { AvE2EProps } from "@av/components/types";

type TextProps = AntdTextProps & AvE2EProps;

export function CustomText(props: TextProps) {
  const { testIdPrefix, ...rest } = props;

  return <Typography.Text data-testid={testIdPrefix + "-text"} {...rest} />;
}
